import React, { Component } from 'react'
import styled, { css } from 'styled-components'

import { colors, rhythm, fonts, media } from '../utils/style-utils'

import FancyNumber from './FancyNumber'
import FancyTitle from './FancyTitle'
import ScrollIndicator from './ScrollIndicator'
import { TweenMax } from 'gsap'

const Grid = styled.section`
  ${media.desktop`
    display: flex;
    flex-direction: ${props => (props.flipped ? 'row-reverse' : 'row')};
    align-items: ${props => (props.flipped ? 'flex-end' : 'flex-start')};
    margin-top: ${props => (props.leader ? rhythm(5) : '0')};
  `};
`

const TextBlockWrapper = styled.div`
  background: ${colors.black};
  color: ${colors.white};
  padding: ${rhythm(2)} ${rhythm(1)};

  ${media.desktop`
    margin-left: auto;
    width: 60%;
    padding: ${rhythm(3)} ${rhythm(5)};
  `};
`

const TextBlockMenu = styled.nav`
  display: block;

  li {
    display: inline-block;
    list-style: none;
    margin-right: 3em;
    ${media.desktop`
      margin-right: 0;
      display: block;
    `};
  }

  li + li {
    margin-top: 0.5rem;
  }
`

const TextBlockMenuItem = styled.button`
  border-radius: 0;
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  color: inherit;
  text-transform: uppercase;

  font-size: 12px;
  letter-spacing: 0.28em;
  line-height: 1.5;
  white-space: nowrap;
  position: relative;

  cursor: pointer;

  &::after {
    position: absolute;
    content: '';
    display: block;
    left: 0;
    top: 100%;
    width: calc(100% - 0.28em);
    border-bottom: 1px solid currentcolor;
    transition: 300ms;
    transform: scaleX(0);
    transform-origin: left;
  }

  &:focus {
    outline: none;
  }

  &:hover::after {
    transform: scaleX(1);
  }
  ${props =>
    props.active &&
    css`
      font-weight: bold;
      &::after {
        transform: scaleX(1);
      }
    `};
`

const Title = styled.h2`
  font-size: 12px;
  letter-spacing: 0.28em;
  line-height: 1.5;
  font-weight: bold;
  text-transform: uppercase;
  max-width: 24em;
`

const TextBlockContent = styled.div`
  margin-top: ${rhythm(1)};
  ${media.desktop`
    margin-top: ${rhythm(3)};
  `};
`

const TextBlockTitle = styled.h3`
  font-family: ${fonts.special};
  font-weight: normal;
  line-height: 1;
  text-align: left;
  font-size: 2rem;
  margin-bottom: ${rhythm(1)};

  ${media.desktop`
    margin-bottom: ${rhythm(2)};
    font-size: 3.33rem;
    text-align: right;
  `};
`

const Header = styled.div`
  margin-top: ${rhythm(2)};
  margin-bottom: ${rhythm(1)};
  ${media.desktop`
    flex-grow: 1;
    flex-direction: column;
    display: flex;
    align-items: flex-end;
    margin: 0;
    margin-top: -${rhythm(3)};
  `} position: relative;
  .title {
    width: 100%;
    margin-right: 10rem;
    ${media.desktop`
    width: auto;
  `};
  }

  .scroller {
    top: 100%;
    left: 6.66rem;
    margin-top: 1rem;
  }
`

class TextBlock extends Component {
  state = {
    activeItem: this.props.multi ? this.props.data.edges[0].node : null,
  }

  updateActiveItem(item) {
    return item !== this.state.activeItem && this.setState({ activeItem: item })
  }

  componentDidUpdate() {
    TweenMax.fromTo(
      this.textEl,
      0.5,
      { opacity: 0, y: '20px' },
      { opacity: 1, y: '0' }
    )
  }

  render() {
    const {
      data,
      number,
      numberTitle,
      blockTitle,
      flipped,
      leader,
      multi,
      scrollTarget,
    } = this.props

    const activeItem = this.state.activeItem

    const activeTitle = multi
      ? activeItem.frontmatter.title
      : data.frontmatter.title

    return (
      <Grid leader={leader} className="l-constrained" flipped={flipped}>
        <Header>
          <FancyNumber>{number}</FancyNumber>
          <FancyTitle className="title">{numberTitle}</FancyTitle>
          {scrollTarget && (
            <ScrollIndicator
              target={scrollTarget}
              button
              className="scroller"
            />
          )}
        </Header>
        <TextBlockWrapper>
          <TextBlockTitle>{blockTitle}</TextBlockTitle>
          {multi && (
            <TextBlockMenu>
              <ul>
                {data.edges.map(item => {
                  const title = item.node.frontmatter.title
                  return (
                    <li key={title}>
                      <TextBlockMenuItem
                        onClick={() => {
                          this.updateActiveItem(item.node)
                        }}
                        active={title === activeTitle}
                      >
                        {item.node.frontmatter.title}
                      </TextBlockMenuItem>
                    </li>
                  )
                })}
              </ul>
            </TextBlockMenu>
          )}

          {!multi && <Title>{data.frontmatter.title}</Title>}
          <TextBlockContent
            innerRef={text => (this.textEl = text)}
            className="c-body"
            dangerouslySetInnerHTML={{
              __html: multi ? activeItem.html : data.html,
            }}
          />
        </TextBlockWrapper>
      </Grid>
    )
  }
}

export default TextBlock



// WEBPACK FOOTER //
// ./src/components/TextBlock.js